import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { PensionSubAccountSettings } from '../../Models/Domains/SubAccount/PensionSubAccountSettings';

declare var IS_RUNNING_IN_APP_POOL;

export class PensionSubAccountSettingsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, useCrystallized: boolean): Promise<PensionSubAccountSettings, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/PensionSubAccountSettings/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, useCrystallized: useCrystallized }

    return AjaxWrapper.get<PensionSubAccountSettings, any>(url, data);
  }
}

